<template>
  <div class="sub-container">
    <v-card class="mx-6 mt-0" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">mdi-account-edit</v-icon>Edit User</span
        >
        <v-spacer />

        <v-btn
          color="purple"
          variant="flat"
          class="btn-text mr-3"
          size="small"
          :to="{ name: 'allusers' }"
        >
          <span class="btn-text"
            ><v-icon class="mx-2">mdi-eye</v-icon>View Users</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card variant="flat" class="mx-6 mt-0">
      <v-card-text>
        <v-form ref="subForm" v-model="isValid">
          <v-row class="mt-n3">
            <!-- <v-col class="mx-3 mt-3" :cols="12" :md="2" :sm="3">Full Name</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start"
              ><v-text-field
                class="mt-2 mx-auto"
                ref="fname"
                :rules="rules.required"
                v-model="formData.username"
                density="compact"
                style="color: #3c3731"
                label="Full Name"
                placeholder="Add a Full Name"
                variant="outlined" /></v-col
          ></v-row>
          <v-row class="mt-n6">
            <!-- <v-col class="mx-3" :cols="12" :md="2" :sm="3">Email</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start"
              ><v-text-field
                class="mt-2 mx-auto"
                ref="lname"
                :rules="rules.required"
                v-model="formData.email"
                density="compact"
                label="Email"
                placeholder="Add email"
                style="color: #3c3731"
                variant="outlined" /></v-col
          ></v-row>
          <v-row class="mt-n6">
            <v-col :cols="12" :md="6" :sm="3" align-self="start">
              <v-text-field
                class="mt-2 mx-auto"
                ref="lname"
                :rules="rules.required"
                v-model="formData.phone"
                density="compact"
                label="Phone Number"
                placeholder="Add phone"
                style="color: #3c3731"
                variant="outlined"
              /> </v-col
          ></v-row>

          <v-row class="mt-n3">
            <!-- <v-col class="mx-3" :cols="12" :md="2" :sm="3">Company name</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start">
              <v-autocomplete
                v-model="formData.company_name"
                :items="companies.length > 0 ? companies : []"
                color="blue-grey-lighten-2"
                item-title="name"
                item-value="id"
                label="Select company"
                chips
                closable-chips
                density="compact"
                style="color: #3c3731"
                variant="outlined"
              ></v-autocomplete>

              <!-- {{
              formData.company_name
            }} -->
            </v-col></v-row
          >

          <v-row class="mt-n3">
            <!-- <v-col class="mx-3" :cols="12" :md="2" :sm="3">List(s)</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start">
              <v-autocomplete
                v-model="selectedGroup"
                :items="['user', 'admin']"
                color="blue-grey-lighten-2"
                item-title="name"
                item-value="id"
                label="List(s)"
                chips
                closable-chips
                density="compact"
                style="color: #3c3731"
                variant="outlined"
              ></v-autocomplete> </v-col
          ></v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="ml-6">
        <v-btn @click="edit()" color="success" variant="flat">
          <span class="btn-text" v-if="!loadingState">
            <v-icon class="mx-1 mt-n1">mdi-account-edit</v-icon>update</span
          >
          <v-progress-circular
            :width="1"
            color="#50568e"
            indeterminate
            v-if="loadingState"
          ></v-progress-circular>
        </v-btn>

        <v-btn
          color="#343a40"
          variant="flat"
          class="mx-2"
          :to="{ name: 'allusers' }"
        >
          <span class="btn-text"
            ><v-icon class="mx-1 mt-n1">mdi-close-circle</v-icon>Cancel</span
          >
        </v-btn>
      </v-card-actions>
      <!-- <editSubsPage :subscribersByID="subscribersByID" :routeId="routeId" v-if="routeParams"/> -->
    </v-card>
  </div>
</template>

<script>
//   import editSubsPage from "@/modules/subscribers/components/editSubsPage.vue";
import eventBus from "@/utils/eventBus";
export default {
  name: "addList",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("subscribers/getLists");
      if (v.$route.params.id !== "") {
        v.$store.dispatch(
          "dashboard/getSingleUser",
          parseInt(v.$route.params.id)
        );
      }
      v.$store.dispatch("roles/getCompanies");
    });
  },
  // components: { editSubsPage },

  data() {
    return {
      isValid: false,
      selectedGroup: null,
      allSubscribers: [],
      loadingState: false,
      screenSize: "",
      oldValue: false,
      test: [],
      newFiltered: [],
      formData: {
        email: "",
        username: "",
        company_name: "",
        id: null,
        is_admin: false,
        listId: null,
        phone: "",
      },

      rules: {
        required: [(value) => !!value || "Required."],
        email: [
          (value) => !!value || "Required.",
          (value) => /.+@.+\..+/.test(value) || "Invalid email address.",
        ],
        password: [(value) => !!value || "Required."],
      },
    };
  },

  computed: {
    companies() {
      return this.$store.getters["roles/rolesGetters"]("companies");
    },
    formattedName() {
      return (item) => `${item.first_name} ${item.last_name}`;
    },
    lists() {
      return this.$store.getters["subscribers/subscribersGetters"]("Lists");
    },
    loaderState() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "loaderState"
      );
    },

    singleUser() {
      return this.$store.getters["dashboard/dashboardGetters"]("user");
    },

    routeParams() {
      return !!this.$route.params.id;
    },
    routeId() {
      return parseInt(this.$route.params.id);
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
    eventBus.on("redirectToList", () => {
      this.$router.push({ name: "ListPage" });
    });
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    save() {
      if (!this.isValid) {
        this.$refs.subForm.validate();
      } else {
        this.formData.subscribers = [...this.newFiltered];
        this.$store.dispatch("list/saveList", this.formData);
      }
    },
    formatPhoneNumber(input) {
      // Convert to string and remove all non-digit characters
      const digits = String(input).replace(/\D/g, "");

      // Take the last 9 digits (e.g., 728736229)
      const lastNine = digits.slice(-9);

      // Add the country code
      return "254" + lastNine;
    },

    async edit() {
      if (confirm(`Are you sure you want to edit user?`)) {
        if (!this.isValid) {
          await this.$refs.subForm.validate();
        } else {
          if (this.selectedGroup === "admin") {
            this.formData.is_admin = true;
          } else {
            this.formData.is_admin = false;
          }
          this.formData.id = parseInt(this.$route.params.id);

          this.formData.phone = this.formatPhoneNumber(
            this.formData.phone
          );

          this.loadingState = true; // Set loading state before dispatch
          try {
            await this.$store.dispatch(
              "dashboard/editSingleUser",
              this.formData
            );
          } finally {
            this.loadingState = false; // Reset loading state after
          }
        }
      }
    },

    getObject(val) {
      console.log(val);
      return val;
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },

    // singleUser: {
    //   handler: function () {
    //     if (this.singleUser !== "undefined") {
    //       this.formData = { ...this.singleUser };
    //       if(this.singleUser.is_admin){
    //         this.selectedGroup ='admin'
    //       }
    //     }
    //   },
    // },

    singleUser: {
      handler(newVal) {
        if (newVal) {
          this.formData = { ...this.singleUser };
          this.selectedGroup = newVal.is_admin ? "admin" : "user";
          this.formData.username = newVal.username ? newVal.username : "N/A";
        }
      },
      immediate: true, // Run this when component loads
      deep: true,
    },
  },
};
</script>

<style>
@import url("../../lists/listStyles.css");
</style>
